module.exports = __webpack_public_path__ + "img/collection-engagementRingsFastDelivery@2x.c718d30.webp";